export default __webpack_public_path__ + "static/banner1-3ad76f4099ace59074aae106c7245bc0.png";